import React, { useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import ReactPlayer from "react-player/lazy";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import PlayerControls from "../../components/player/PlayerControls";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import screenfull from "screenfull";
import { screeningsData } from "../../utils/screenings";
import Form from "../../components/Form";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    width: 960,
    marginTop: 80,
  },
  contents: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "100%",
    marginTop: 100,
  },
  playerWrapper: {
    width: "960px",
    height: "539px",
    position: "relative",
    border: "1px solid #c6c6c6",
  },
  titleMain: {
    zIndex: 10,
    width: "400px",
    top: 0,
    left: 0,
    right: 0,
    "&> div": {
      marginLeft: 16,
      marginTop: 16,
      color: "#fff",
      padding: 12,
      borderRadius: 4,
      background: "#333333",
      width: 300,
      textAlign: "center",
    },
  },
  next: {
    zIndex: 10,
    width: "100%",
    height: "100%",
    padding: 16,
    "& > div": {
      width: 150,
      height: 45,
      backgroundColor: "rgb(47 55 61 / 95%)",
      borderRadius: 5,
      color: "rgb(240 240 240)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      lineHeight: 1.5,
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "rgb(47 55 61 / 100%)",
        color: "#fff",
      },
    },
  },
  playerMain: {
    position: "absolute",
    width: "100%",
    height: "100%",
    background: "#333",
    zIndex: 12,
    border: "1px solid #333333",
    backgroundImage:
      "linear-gradient(rgb(51 51 51 / 55%), rgb(0 0 0 / 87%)),url(/images/prostate/prostate_0.png)",
    backgroundSize: "962px 540px",
  },
}));
const format = (seconds) => {
  if (isNaN(seconds)) {
    return `00:00`;
  }
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = date.getUTCSeconds().toString().padStart(2, "0");
  if (hh) {
    return `${hh}:${mm.toString().padStart(2, "0")}:${ss}`;
  }
  return `${mm}:${ss}`;
};
let count = 0;
const ProstateMain = () => {
  const classes = useStyles();
  const history = useHistory();
  const [state, setState] = useState({
    playing: false, // 재생
    muted: false, // 음소거
    volume: 0.5, // 음량
    playbackRate: 1.0, // 재생 속도
    played: 0,
    seeking: false,
    nCount: 0,
    start: false,
  });
  const [now] = useState(screeningsData[1].scenario);
  const [bookmarks, setBookmarks] = useState([]);
  const playerRef = useRef(null);
  const playerContainerRef = useRef(null);
  const canvasRef = useRef(null);
  const controlsRef = useRef(null);

  const {
    playing,
    muted,
    volume,
    playbackRate,
    played,
    seeking,
    nCount,
  } = state;
  const handlePause = () => {
    setState({ ...state, playing: !state.playing });
  };
  const handleMuted = () => {
    setState({
      ...state,
      muted: !state.muted,
      volume: state.muted ? 0.5 : 0,
    });
  };
  const handleRewind = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() - 10);
  };
  const handleFastForward = () => {
    playerRef.current.seekTo(playerRef.current.getCurrentTime() + 10);
  };
  const handleVolumeChange = (e, newValue) => {
    setState({
      ...state,
      volume: parseFloat(newValue / 100),
      muted: newValue === 0 ? true : false,
    });
  };
  const handleVolumeSeekDown = (e, newValue) => {
    setState({
      ...state,
      volume: parseFloat(newValue / 100),
      muted: newValue === 0 ? true : false,
    });
  };
  const handlePlaybackRateChange = (rate) => {
    setState({
      ...state,
      playbackRate: rate,
    });
  };
  const handleToggleFullScreen = (e) => {
    e.stopPropagation();
    screenfull.toggle(playerContainerRef.current);
  };
  const handleProgress = (changeState) => {
    if (count > 3) {
      controlsRef.current.style.visibility = "hidden";
      count = 0;
    }
    if (controlsRef.current.style.visibility === "visible") {
      count += 1;
    }

    if (!seeking) {
      setState({
        ...state,
        ...changeState,
      });
    }
  };

  const handleSeekChange = (e, newValue) => {
    setState({ ...state, played: parseFloat(newValue / 100) });
  };

  const handleSeekMouseDown = (e) => {
    setState({ ...state, seeking: true });
  };

  const handleSeekMouseUp = (e, newValue) => {
    setState({ ...state, seeking: false });
    playerRef.current.seekTo(newValue / 100, "fraction");
  };
  const handleTrackGoE = (e, index) => {
    e.stopPropagation();
    if (now.length === index + 1) {
      if (
        playerContainerRef.current.clientWidth !== 958 &&
        playerContainerRef.current.clientHeight !== 539
      ) {
        screenfull.toggle(playerContainerRef.current);
      }
    }
    handleTrackGo(index + 1);
  };
  const addBookmark = () => {
    const canvas = canvasRef.current;
    canvas.width = 160;
    canvas.height = 90;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(
      playerRef.current.getInternalPlayer(),
      0,
      0,
      canvas.width,
      canvas.height
    );
    const dataUri = canvas.toDataURL();
    canvas.width = 0;
    canvas.height = 0;
    const bookmarksCopy = [...bookmarks];
    bookmarksCopy.push({
      time: playerRef.current.getCurrentTime(),
      display: format(playerRef.current.getCurrentTime()),
      image: dataUri,
    });
    setBookmarks(bookmarksCopy);
  };
  const handleMouseMove = () => {
    if (nCount + 1 === now.length) {
      return false;
    }
    if (state.played === 1) {
      return false;
    }
    controlsRef.current.style.visibility = "visible";
    count = 0;
  };
  const handleMouseOut = () => {
    controlsRef.current.style.visibility = "hidden";
    count = 0;
  };
  const handleMovieChange = () => {
    if (state.nCount + 1 < now.length) {
      setState({ ...state, nCount: state.nCount + 1 });
    }
  };
  const handleMovieTrackDown = () => {
    if (state.nCount >= 1) {
      setState({ ...state, nCount: state.nCount - 1 });
    }
  };
  const handleStop = (e) => {
    e.stopPropagation();
    handlePause();
  };
  const handleTrackGo = (index) => {
    if (now.length === index + 1) {
      if (
        playerContainerRef.current.clientWidth !== 958 &&
        playerContainerRef.current.clientHeight !== 539
      ) {
        screenfull.toggle(playerContainerRef.current);
      }
    }
    setState({ ...state, nCount: index });
  };
  const handleHome = (e) => {
    e.stopPropagation();
    history.push("/");
  };
  const currentTime = playerRef.current
    ? playerRef.current.getCurrentTime()
    : "00:00";
  const duration = playerRef.current
    ? playerRef.current.getDuration()
    : "00:00";
  const elapsedTime = format(currentTime);
  const totalDuration = format(duration);
  // React.useEffect(() => {
  //   // if (state.played === 1) {
  //   //   handleMovieChange();
  //   // }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [state.played]);
  const handlePlay = () => {
    setState({
      ...state,
      start: true,
      playing: true,
    });
  };
  return (
    <>
      <Grid
        container
        justify="center"
        alignItems="center"
        className={classes.root}
      >
        {!state.start && (
          <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.playerMain}
          >
            <IconButton
              color="primary"
              aria-label="add an alarm"
              onClick={handlePlay}
            >
              <PlayArrowIcon style={{ fontSize: 120 }} />
            </IconButton>
          </Grid>
        )}

        <div
          ref={playerContainerRef}
          className={classes.playerWrapper}
          onMouseMove={handleMouseMove}
          onMouseOut={handleMouseOut}
          onClick={handleStop}
        >
          <Grid
            container
            className={classes.titleMain}
            style={{ position: "absolute" }}
          >
            <div>{now[nCount].title}</div>
          </Grid>
          {state.played === 1 && nCount + 1 !== now.length && (
            <Grid
              container
              alignItems="flex-end"
              justify="flex-end"
              className={classes.next}
              style={{ position: "absolute" }}
            >
              <div onClick={(e) => handleTrackGoE(e, nCount)}>
                다음
                <ArrowForwardIcon />
              </div>
            </Grid>
          )}
          <ReactPlayer
            url={now[nCount].url}
            muted={muted}
            width={"100%"}
            height={"100%"}
            playing={playing}
            ref={playerRef}
            volume={volume}
            playbackRate={playbackRate}
            onProgress={handleProgress}
            allow="autoplay"
            style={{
              display: nCount + 1 === now.length && "none",
            }}
            config={{
              file: {
                attributes: {},
              },
            }}
          />
          {nCount + 1 === now.length && <Form name={screeningsData[1].name} />}
          <PlayerControls
            ref={controlsRef}
            onPlayPause={handlePause}
            playing={playing}
            muted={muted}
            volume={volume}
            onRewind={handleRewind}
            onFastForward={handleFastForward}
            onVolumeSeekDown={handleVolumeSeekDown}
            onVolumeChange={handleVolumeChange}
            onMuted={handleMuted}
            playbackRate={playbackRate}
            onPlaybackRateChange={handlePlaybackRateChange}
            onToggleFullScreen={handleToggleFullScreen}
            played={played}
            onSeek={handleSeekChange}
            onSeekMouseDown={handleSeekMouseDown}
            onSeekMouseUp={handleSeekMouseUp}
            elapsedTime={elapsedTime}
            totalDuration={totalDuration}
            onBookmark={addBookmark}
            onMoviePlus={handleMovieChange}
            onMovieTrackDown={handleMovieTrackDown}
            nCount={nCount}
            leng={now.length}
            title={now[nCount].title}
            cancerData={screeningsData[1]}
            onTrackGo={handleTrackGo}
            onGoHome={handleHome}
            style={{
              display:
                (nCount + 1 === now.length || state.played === 1) && "none",
            }}
          />
        </div>
      </Grid>
    </>
  );
};

export default ProstateMain;
